import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import TagManager from 'react-gtm-module';

import PageFooter from '../../Helpers/PageFooter';

import { ApplicantTypes } from '@interfaces/userApplication/userApplication';
import { ENV_VARS, verifyEnvVar } from '@env/usage';

import Success from '@buyside/svgs/userApplicationNavigation/success.svg';

import styles from '../pageStyles.scss';

const ProSuccessPage: React.FunctionComponent<{
  applicantType: ApplicantTypes;
}> = ({ applicantType }): React.ReactElement => {
  TagManager.initialize({
    auth: verifyEnvVar(ENV_VARS.GTM_AUTH),
    dataLayer: { event: 'Account Signup', page: 'apply', applicantType },
    gtmId: 'GTM-5DKKZ3G',
    preview: verifyEnvVar(ENV_VARS.GTM_PREVIEW)
  });

  return (
    <>
      <Success />
      <h1>Application Submitted</h1>
      <div className={styles.inputForm}>
        <div className={styles.inputField}>
          <p>
            Thank you for applying to SumZero. Your application will be reviewed by a SumZero
            administrator and you will receive a response shortly.
          </p>
        </div>
        <div className={styles.socialContainer}>
          <div className={styles.socialHeading}>Follow Us</div>
          <p>
            Follow us on YouTube as we chat with some of the best minds in the buyside community.
          </p>
          <div className={styles.iconContainer}>
            <a href="https://www.youtube.com/c/SumZeroInc" target="_blank">
              <FontAwesomeIcon className={styles.socialIcon} icon={faYoutube} />
            </a>
            <a href="https://twitter.com/SumZero" target="_blank">
              <FontAwesomeIcon className={styles.socialIcon} icon={faTwitter} />
            </a>
            <a href="https://www.facebook.com/SumZeroInc/" target="_blank">
              <FontAwesomeIcon className={styles.socialIcon} icon={faFacebookF} />
            </a>
          </div>
          <div className={styles.emailUs}>
            Questions? Contact us at <a href="mailto:support@sumzero.com">support@sumzero.com</a>
          </div>
        </div>
      </div>
      <PageFooter />
    </>
  );
};

export default ProSuccessPage;
